import Specialty from './Specialty'
import { Option } from './Specialty'

export class Anesthesiology extends Specialty {
  static entity = 'anesthesiology'
  static baseEntity = 'specialties'

  static fields() {
    return {
      ...super.fields(),
      locoRegionalTree: this.attr({})
    }
  }

  static getLabel(log, component) {
    if (component.id === 'anesthesia-procedure') {
      return this.getProcedureLabel(log)
    } else if (component.id === 'anesthesia-type') {
      return this.getAnesthesiaType(log)
    } else if (component.id === 'loco-regional-anesthesia') {
      return this.getLocoRegionalLabel(log, false)
    } else if (component.id === 'duration') {
      if (log.durationHours === undefined) {
        return log.duration || ''
      } else if (
        log.durationHours !== undefined &&
        log.durationMinutes !== undefined
      ) {
        return `${log.durationHours
          .toString()
          .padStart(2, '0')}:${log.durationMinutes.toString().padStart(2, '0')}`
      } else {
        return ''
      }
    } else {
      return super.getLabel(log, component)
    }
  }

  static getOptionLabel(id) {
    return (Option.all().find(option => option.value === id) || {}).text
    // return this.$i18n.locale === 'pt' ? option.text : option.value
  }

  static getTreeLabels(tree, labels) {
    if (!labels) return ''
    if (Array.isArray(labels)) {
      const treeLabel = this.getTreeLabel(tree, labels[0])
      return labels.length > 1 ? `${treeLabel}...` : treeLabel
    } else {
      return this.getTreeLabel(tree, labels)
    }
  }

  static getUntruncatedTreeLabels(tree, labels) {
    let items = labels
    if (!Array.isArray(labels)) items = [labels]
    return items.map(item => this.getTreeLabel(tree, item)).join(', ')
  }

  static getTreeLabel(tree, id) {
    for (const child of tree) {
      if (child.id === id) return child.name
      else if (child.children) {
        const label = this.getTreeLabel(child.children, id)
        if (label) return label
      }
    }
    return ''
  }

  static getLocoRegionalTree() {
    return Anesthesiology.all()[0].locoRegionalTree || {}
  }

  static getProcedureLabel(log) {
    let value
    if (log['general-anesthesia']) {
      value = Option.all().find(
        opt =>
          opt.component === 'general-anesthesia' &&
          opt.value === log['general-anesthesia']
      )
    }
    const genAnesthesiaType = value ? value.text : ''
    const locoregionalType = this.getLocoRegionalLabel(log)

    let procedureLabel = ''
    procedureLabel += genAnesthesiaType ? `Geral: ${genAnesthesiaType}\n` : ''
    procedureLabel += locoregionalType
      ? `Locoregional: ${locoregionalType}\n`
      : ''
    procedureLabel += log['sedoanalgesia']
      ? `${this.getOptionLabel('sedoanalgesia')}\n`
      : ''
    procedureLabel += log['cam'] ? `${this.getOptionLabel('cam')}\n` : ''
    return procedureLabel.trimRight()
  }

  static getLocoRegionalLabel(log, truncated = true) {
    const items = log['loco-regional-anesthesia'] || []
    return truncated
      ? this.getTreeLabels(this.getLocoRegionalTree(), items)
      : this.getUntruncatedTreeLabels(this.getLocoRegionalTree(), items)
  }

  static getAnesthesiaType(log) {
    if (log['combined-anesthesia']) return 'Combinada'
    const anesthesiaTypes = {
      // use an object since the id's on the Options don't match the keys in log
      'general-anesthesia': 'general',
      'loco-regional-anesthesia': 'loco-regional',
      sedoanalgesia: 'sedoanalgesia',
      cam: 'cam'
    }

    const types = []

    for (const k of Object.keys(anesthesiaTypes)) {
      if (log[k]) {
        types.push(
          Option.all().find(
            opt =>
              opt.component === 'anesthesia-type' &&
              opt.value === anesthesiaTypes[k]
          ).text || anesthesiaTypes[k]
        )
      }
    }

    return types.length ? types.join(', ') : ''
  }
}
